import { render, staticRenderFns } from "./pics.vue?vue&type=template&id=4a6fae36&"
import script from "./pics.vue?vue&type=script&lang=js&"
export * from "./pics.vue?vue&type=script&lang=js&"
import style0 from "./pics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports